var _defs, _path, _path2, _text, _rect, _text2, _path3, _path4, _text3, _path5, _path6, _text4, _path7, _path8, _rect2, _text5, _path9, _path10, _text6, _rect3, _text7, _rect4, _text8, _path11, _text9, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryImage6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "481px",
    height: "522px",
    viewBox: "-0.5 -0.5 481 522",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-09-30T06:05:41.059Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.61 Safari/537.36\" etag=\"oO-TI5QZv1sjuxRxzcEl\" version=\"15.3.8\" type=\"google\"><diagram id=\"4w-ZONJ2FCJr-dnYB4VA\" name=\"Page-1\">5Vlbl5s2EP41Pm0f8AFhbHhc25tNzqatT5xtdvsmg2zUACJC+JJf3xGIi2zsul6nm039gubCaNDMfDPgnj2Jt3ccp+GvLCBRD5nBtmdPewhZrufBRXJ2JWc4dEvGitNAKTWMOf1KFNNU3JwGJNMUBWORoKnO9FmSEF9oPMw52+hqSxbpu6Z4RQ4Ycx9Hh9xPNBBhyXXRqOG/JXQVVjtbQ/XAMa6U1ZNkIQ7YpsWyb3v2hDMmylW8nZBIHl51LuV9b45Ia8c4ScQ5N/wRW5N5PEvZ7P6T79lP94b3xbBLK2sc5eqBe2gYgb3xkoFZ8Frs1FEMv+SsEhhZEagbULAG6bYRwmolr3OSBD3pUCV4AOpBbjVFmjaOU1gkiywtaPPnD/mCfv4pg+UkXxC4/MYEFpQl2S+Va/CMpXflXup4a0cRCSCEikxYApexn/M1kQdhAcFZngQFZQLFuAjZiiU4es9YqlT+IkLsVDbiXDBghSKOlBROnO8e5f19pyKflLmCmG41aldTwY3MSSBZShLgZAJzofaxBqVKm8xYzn0yI5zGRBA+T7FPkxVIXRDCvSsijggP00NlTGmyZH14YtbHPw02evd454m3PJ+hB6Mqs8L6CT1U6snTbm2gku+OMHCK70CBkwgCuNYLCqu6XNV6TerCQmVvdyaf8vo5mex1ZfKExWkOp3tu8unJtQmpIDIwUroBiNQTKcR+mHNyJ/lTGe+U0QQ2u11D1DJl42gk14QLsj159ko6UBikQNhR5KZBNKuCqbCFZkPzGwXLeX6wht3BgnpjcnsRSuyImWBcYgn2fcYDWR2yf9TyGlu+I2h5DRCBzoSIwUtBRGezG/zY4Wx1JdMcaH2pb3voH3sTULXlirml4rG1fmp6HlCNJUlUhs7Kqs74ONfOFnXrTIJqCwyt/sA1mx/SsHFk9x3La36ubl5FoLTYnrb2NjGQp5lFnqMbUnHeNwTZgncttaIhZMcfxqgn5V01cpunHfN0xwaaOixKD5oqqw/+8sJzD+D+YD78/b6N5h1l+h4v4NVCKy4c0RWU1NQnSZGyY9kQKczuN0oQ0yCQNsacQOfAi8KeWbXZ4oSdcc+ZdmbtKQg56Lz1C4jaRJvxuzqyYfYtB6mcuDShKxW2XGZE9Pbx8QqRG/1vINNzLR0yB+7wEsi8alN9SZhEso20ULJ65a0BbW84PIKMF2TiqdPpGBmzFCeXz/dzFq3ldG++oTzeQNhao2Bp+RUP+vUE/2KTvnWFuI264vZxQzNxbqx+KNC6HGEGZ47tlvVSc/spt6/+aj8XJE2L2i/eE6XrxVQyJ3zNGu4rfu839vDAdp0DPEDuf4oHx7/TPA/H978bvmIQR3tfa6wOEB9+o6Cdmjiu/pX43bL+EpNVbXhJE5qFJKslAmefzy7CkMWLPPt+QmnsBxPZh8FEXR3ZMv99NIFs/k8oB6/mXxn79m8=</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 320 68 Q 320 68 320 207.76",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 193.88 L 320 208.88 L 327.5 193.88",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 139,
      marginLeft: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Send \"U U2 D2\"\xA0 (Rubik's Cube Notations)"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 142,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Send \"U U2 D2\"\xA0 (Rubik's Cube Notations)")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 0,
    width: 120,
    height: 60,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 30,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 19
    }
  }, "Computer"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 34,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Computer")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 320 278 Q 320 278 320 324.76",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 310.88 L 320 325.88 L 327.5 310.88",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 303,
      marginLeft: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Control the motors according to the Notations"))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 306,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Control the motors according to the Notations")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 230 Q 10 130 65.5 60 Q 121 -10 259.31 23",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 244.06 27.07 L 260.39 23.26 L 247.54 12.48",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 69,
      marginLeft: 59
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Send \"OK\"")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 59,
    y: 72,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Send \"OK\"")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 252 232.56 Q 252 232.56 218.04 228.84",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 232.66 222.9 L 216.93 228.72 L 231.03 237.81",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 210,
    width: 120,
    height: 60,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 240,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 19
    }
  }, "Solver Firmware"))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 244,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Solver Firmware")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 320 403 Q 320 403 320 449.76",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 435.88 L 320 450.88 L 327.5 435.88",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 428,
      marginLeft: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 17
    }
  }, "Twist"))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 431,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Twist")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 335,
    width: 280,
    height: 60,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 278,
      height: 1,
      paddingTop: 365,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 19
    }
  }, "Stepper motor and Servo motor"))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 369,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Stepper motor and Servo motor")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 460,
    width: 160,
    height: 60,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 490,
      marginLeft: 241
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 19
    }
  }, "Rubik's Cube"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 494,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Rubik's Cube")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 110 180 L 220 230 L 110 280 L 0 230 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 218,
      height: 1,
      paddingTop: 230,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "If the solver finishes the task"))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 234,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "If the solver finishes the task"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryImage6);
export default __webpack_public_path__ + "static/media/Gallery_Image6.669b4cee6a617016af6a7d1ca0780705.svg";
export { ForwardRef as ReactComponent };